import React from 'react';
import { Box, Button, Card, CardContent, Chip, Divider, Stack, Typography } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { BOOKING_STATUS_COLORS } from '../../../helpers/constants';
import { formatDateTimeInVenueTz } from '../../../helpers/formatDateTime';

const BookingCard = ({ booking }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Card
            variant="outlined"
            sx={{
                minWidth: 0,
                maxWidth: 380,
                flex: '1 1 0',
            }}
        >
            <CardContent>
                <Stack spacing={1.5}>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                            #{booking.id}
                        </Typography>
                        {booking.status && (
                            <Chip
                                size="small"
                                label={t(`widgetReservationInfo.statusValues.${booking.status}`)}
                                sx={{
                                    background: BOOKING_STATUS_COLORS[booking.status] || '#ccc',
                                    color: '#fff',
                                }}
                            />
                        )}
                    </Stack>

                    <Box>
                        <Typography variant="caption" color="text.secondary">
                            {t('bookings.columns.showName')}
                        </Typography>
                        <Typography variant="body2">
                            {booking.timeslot?.showTitle || '-'}
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="caption" color="text.secondary">
                            {t('bookings.columns.timeslot')}
                        </Typography>
                        <Typography variant="body2">
                            {booking.timeslot?.startTime
                                ? formatDateTimeInVenueTz(booking.timeslot.startTime)
                                : '-'}
                        </Typography>
                    </Box>

                    {booking.confirmationCode && (
                        <Box>
                            <Typography variant="caption" color="text.secondary">
                                {t('bookings.columns.confirmationCode')}
                            </Typography>
                            <Typography variant="body2">{booking.confirmationCode}</Typography>
                        </Box>
                    )}

                    {booking.ticketTypes?.length > 0 && (
                        <Box>
                            <Typography variant="caption" color="text.secondary">
                                {t('bookings.columns.ticketTypes')}
                            </Typography>
                            {booking.ticketTypes.map((tt, i) => (
                                <Typography key={i} variant="body2">
                                    {`${tt.count} - ${tt.name}`}
                                </Typography>
                            ))}
                        </Box>
                    )}

                    <Box>
                        <Typography variant="caption" color="text.secondary">
                            {t('bookings.columns.pax')}
                        </Typography>
                        <Typography variant="body2">{booking.pax || 0}</Typography>
                    </Box>

                    <Divider />

                    <Button
                        size="small"
                        startIcon={<OpenInNewIcon />}
                        onClick={(event) => {
                            event.stopPropagation();
                            navigate(`/bookings/edit/${booking.id}`);
                        }}
                    >
                        {t('crm.viewBooking')}
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
};

export default BookingCard;
